import(/* webpackMode: "eager" */ "/vercel/path0/src/app/services/digital-packaging-labels/page.jsx");
